<template>
  <v-form @submit.prevent="login">
    <h2 class="headline pb-2">
      You must log in to see this page
    </h2>
    <v-text-field
      v-model="user.username"
      solo
      flat
      type="text"
      placeholder="Username"
    />
    <v-text-field
      v-model="user.password"
      solo
      flat
      type="password"
      placeholder="Password"
    />
    <v-btn depressed class="ma-0" type="submit">
      Log in
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      user: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      this.$store.dispatch("login", this.user);
    }
  }
};
</script>

<style scoped lang="less">
form {
  /* Just to center the form on the page */
  margin: 0 auto;
  width: 400px;
  /* To see the outline of the form */
  padding: 1em;
  border: 1px solid #ccc;
  border-radius: 1em;
}
</style>
